
export class AvisInitialType {

	public datePublication: string;

	public idWeb: string;

	constructor() {
		this.idWeb = '';
		this.datePublication = '';
	}

}
